const openModals = [];
export default openModals;
